<template>
  <MoleculeLogOut/>
</template>

<script>
export default {
  name: 'OrganismLogOut',

  components: {
    MoleculeLogOut: () => import('@/components/molecules/MoleculeLogOut')
  }
}
</script>
